import getCdnUrl from '../../../helpers/get-cdn-url';

const MobileBackground = getCdnUrl('/landings/background-mobile@2x-80q.webp');

export default MobileBackground;
